export default __webpack_public_path__ + "static/media/post-02-detail.c89d409b.jpg";